import { GAME_VERSION, GAME_BUILD_HASH } from './version.generated.js';

export const GAME = {
  // Jugadores
  MIN_PLAYERS: 2,
  MAX_PLAYERS: 32,

  // Partida
  MATCH_TIME_LIMIT_MS: 600000, // 10 min
  MIN_MATCH_TIME_MS: 300000, // 5 min

  // Orbes
  ORBS_INITIAL_COUNT: 12,
  ORBS_MAX_COUNT: 20,
  ORB_RESPAWN_TICKS: 90, // 3s
  ORB_VALUE: 1,

  // Upgrades
  MAX_UPGRADE_LEVEL: 4,

  // Lobby
  LOBBY_WAIT_TIME_MS: 30000, // 30s max wait
  MATCH_COUNTDOWN_SECONDS: 10,

  // Matchmaking
  MMR_START_RANGE: 100,
  MMR_MAX_RANGE: 500,
  MMR_RANGE_STEP: 50,
  MMR_WAIT_TIME_STEP_MS: 5000,

  // Version
  GAME_VERSION,
  GAME_BUILD_HASH,
  PROTOCOL_VERSION: 1,

  // Redis
  REDIS_KEY_PREFIX: 'pushio:',
  REDIS_SESSION_TTL: 3600,
  REDIS_MATCH_TTL: 7200,

  // Rate Limiting
  MAX_INPUTS_PER_TICK: 2,
  MAX_MESSAGES_PER_SECOND: 100,
  INPUT_TIMEOUT_MS: 30000,
} as const;
